import { useState } from 'react';
import { Container, Form, InputGroup } from 'react-bootstrap';

export const SearchFilterBar = ({
  value = '',
  onChange,
  filterOptions = [],
  activeFilter = '',
  onFilterChange,
}) => {
  return (
    <section className="csd-toolbar">
      <Container>
        <div className="csd-toolbar__inner">
          <InputGroup className="csd-search">
            <Form.Control
              type="text"
              placeholder="Search..."
              value={value}
              onChange={(e) => onChange && onChange(e.target.value)}
              className="csd-search__input"
            />
            <InputGroup.Text className="csd-search__icon">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#9aacbc"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
            </InputGroup.Text>
          </InputGroup>

          <div className="csd-filter-wrap">
            <span className="csd-filter-label">Use Filter :</span>
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#52677d"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
            </svg>
            {filterOptions.length > 0 && (
              <div className="csd-filter-dropdown">
                {filterOptions.map((opt) => (
                  <button
                    key={opt}
                    className={`csd-filter-option${activeFilter === opt ? ' csd-filter-option--active' : ''}`}
                    onClick={() => onFilterChange && onFilterChange(opt)}
                  >
                    {opt}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </Container>
    </section>
  );
};
